import styled from 'styled-components';

export const NavBar = styled.nav`
  height: calc(100vh - 75px);
  background: var(--primary);
  z-index: 999;
  position: relative;
  transition: all 0.5s ease-in;
  width: 100px;
  @media (min-width: 739px) {
    width: ${({ open }) => (open ? '256px' : '100px')};
    &:hover {
      & ul {
        width: 256px;
        position: ${({ open }) => (open ? 'initial' : 'fixed')};
        & li a h1 {
          visibility: visible;
        }
      }
    }
  }
  @media (max-width: 499px) {
    width: 80px;
  }
`;

export const MobileContainer = styled.div`
  margin-left: 25px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const NavigationList = styled.ul`
  list-style: none;
  height: 100%;
  background: var(--primary);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 75px);
  transition: all 0.5s ease-in;
  width: 100px;
  @media (min-width: 739px) {
    width: ${({ open }) => (open ? '256px' : '100px')};
    & li a h1 {
      visibility: ${({ open }) => (open ? 'visible' : 'hidden')};
    }
  }
  @media (max-width: 499px) {
    width: 80px;
  }

  ::-webkit-scrollbar {
    width: 7px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #888;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
